<div class="modal-header">

    <p class="modal-title"><strong> Save template </strong></p>
    <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>

</div>

<div class="modal-body lg">
    <div class="col-12 mt-3">
        <!-- Template form -->
        <form [formGroup]="templateForm" *ngIf="!isExit">
            <div class="form-group">
                <div class="row">

                    <div class="col-md-3 col-lg col-sm-4 filter-field">
                        <ng-multiselect-dropdown #multiSelect name="employee-category"
                            formControlName="employeeCategory" class="form-control form-control-sm"
                            [placeholder]="'Employee Category'" [data]="empCategories" [settings]="dropdownSettings">
                        </ng-multiselect-dropdown>
                    </div>
                    <div class="col-md-3 col-lg col-sm-4 filter-field">
                        <ng-multiselect-dropdown #multiSelect name="office-location" formControlName="officeLocation"
                            class="form-control form-control-sm" [placeholder]="'Office location'"
                            [data]="officeLocations" [settings]="dropdownSettings">
                        </ng-multiselect-dropdown>
                    </div>
                    <div class="col-md-3 col-lg col-sm-4 filter-field">
                        <ng-multiselect-dropdown #multiSelect name="pb-type" formControlName="pbType"
                            class="form-control form-control-sm" [placeholder]="'Preboarding type'" [data]="pbTypes"
                            [settings]="dropdownSettings">
                        </ng-multiselect-dropdown>
                    </div>
                    <div *ngIf="showControl" class="checkbox-inline">
                        <input formControlName="isWSO" type="checkbox" class="check-input mt-1">
                        <label class="ml-1">
                            Is Transfer type within the same office?
                        </label>
                    </div>
                    <div class="col-md-2 col-sm-2">
                        <button eosDebounce [disabled]="!enableSearch" class="btn btn-primary"
                            (debounceClick)="search()">Search</button>
                    </div>
                </div>

            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-6">
                        <input type="text" formControlName="templateSearch" class="form-control form-control-sm">
                    </div>

                </div>
            </div>

            <div class="form-group" *ngIf="isDataAvailable">
                <div class="fa-pull-right">
                    <a [routerLink]="" (click)="selectAll()">select all</a> |
                    <a [routerLink]="" (click)="unselectAll()">unselect all</a>
                </div>
                <div class="table-resp candid-table">
                    <table class="table table-bordered">
                        <tr>
                            <th>Action </th>
                            <th> Activity Header </th>
                            <th> Pre-boarding Type </th>
                            <th> Office Location </th>
                            <th> Employee Category </th>

                        </tr>

                        <tr *ngFor="let temp of templateList">
                            <td> <input type="checkbox" class="check-input" (change)="onCheckChange(temp)"
                                    [value]="temp.id" [checked]="temp.checked">
                            </td>
                            <td>{{temp.activityHeader}} </td>
                            <td>{{temp.pbType}}</td>
                            <td>{{temp.officeLocation}}</td>
                            <td>{{temp.employeeCategory}}</td>
                        </tr>

                    </table>
                </div>
            </div>

        </form>
        <!--Template Form ends -->

        <!-- Exit Template Form -->
        <form [formGroup]="exitTemplateForm" *ngIf="isExit">
            <div class="form-group">
                <div class="row">
                    <div class="col-md-3 col-lg col-sm-4 filter-field">
                        <ng-multiselect-dropdown #multiSelect name="exit-type" formControlName="exitType"
                            class="form-control form-control-sm" [placeholder]="'Exit type'" [data]="exitTypes"
                            [settings]="dropdownSettings">
                        </ng-multiselect-dropdown>
                    </div>
                    <div class="col-md-3 col-lg col-sm-4 filter-field">
                        <ng-multiselect-dropdown #multiSelect name="office-location" formControlName="officeLocation"
                            class="form-control form-control-sm" [placeholder]="'Office location'"
                            [data]="officeLocations" [settings]="dropdownSettings">
                        </ng-multiselect-dropdown>
                    </div>
                    <div class="col-md-2 col-sm-2">
                        <button eosDebounce [disabled]="!enableSearch" class="btn btn-primary"
                            (debounceClick)="search()">Search</button>
                    </div>
                </div>

            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-6">
                        <input type="text" formControlName="templateSearch" class="form-control form-control-sm">
                    </div>

                </div>
            </div>

            <div class="form-group" *ngIf="isDataAvailable">
                <div class="fa-pull-right">
                    <a [routerLink]="" (click)="selectAll()">select all</a> |
                    <a [routerLink]="" (click)="unselectAll()">unselect all</a>
                </div>
                <div class="table-resp candid-table">
                    <table class="table table-bordered">
                        <tr>
                            <th>Action </th>
                            <th> Activity Header </th>
                            <th> Exit Type </th>
                            <th> Office Location </th>
                        </tr>

                        <tr *ngFor="let temp of templateList">
                            <td> <input type="checkbox" class="check-input" (change)="onCheckChange(temp)"
                                    [value]="temp.id" [checked]="temp.checked">
                            </td>
                            <td>{{temp.activityHeader}} </td>
                            <td>{{temp.exitType}}</td>
                            <td>{{temp.officeLocation}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </form><!-- Exit template Form ends -->
        
        <div class="row" *ngIf="templateList &&  templateList.length>0">
            <div class="col-xs-10 col-10">
                <pagination [totalItems]="sortParameters.totalRecords" [itemsPerPage]="sortParameters.itemsPerPage"
                    [maxSize]="5" [(ngModel)]="currentPage" (pageChanged)="pageChanged($event)"></pagination>
            </div>

            <div class="col-xs-2 col-2">
                <select (change)="onSelectChanges()" [(ngModel)]="sortParameters.itemsPerPage"
                    class="form-control form-control-sm">
                    <option *ngFor="let count of changeCount" [value]="count">{{count}}</option>
                </select>
                <p>Per page</p>
            </div>

        </div>

        <div *ngIf="!isDataAvailable" class="row p-3">
            <div class="col text-center text-dark">
                <p class="h6 font-weight-bold text-muted">No templates to show!</p>
            </div>
        </div>


        <div class="row mt-2 mb-3">
            <div class="col-12 mt-4 text-center">
                <button [disabled]="tempSelected.length === 0" eosDebounce class="btn btn-secondary me-2"
                    (debounceClick)="save()">Save</button>
            </div>
        </div>

    </div>
</div>
